
import React from 'react';
import './SearchCSS.css'


export class SearchComponent extends React.Component {
    constructor(props) {
        super(props);
        const isSpanish = window.location.pathname.slice(0, 4) === '/es' || window.location.pathname.slice(0, 4) === '/es/'
        const culture = isSpanish ? 'es' : 'en';
        this.state = {
            Suggestions: [],
            culture,
            text : '',
        }
        ///restapi/search/suggestions?IndexName=generalsitesearch&SuggestionFields=Title%2CContent&Text=flight&Language=es
// {"Suggestions":["Flights-SP","Reviewing Flight History-SP","flight schedules to and from Phoenix","Flight Airport Parking (602) 267-0166","Flight/Internal Phone #: 801-401-9000"]}
    }

    debounced = (func, wait, immediate) => {
        let timeout;

        return function () {
            let context = this, args = arguments;
            let later = function () {
                timeout = null;
                if (!immediate) func.apply(context, args);
            };
            let callNow = immediate && !timeout;
            clearTimeout(timeout);
            timeout = setTimeout(later, wait);
            if (callNow) func.apply(context, args);
        };
    };

    search = this.debounced((text) => {

         fetch(`/restapi/search/suggestions?IndexName=default&SuggestionFields=Title%2CContent&Text=${text}&Language=${this.state.culture}`)
        //fetch(`http://avnwbw004:7878/restapi/search/suggestions?IndexName=default&SuggestionFields=Title%2CContent&Text=${text}&Language=${this.state.culture}`)
            .then(response => response.json())
            .then(response => this.setState(Object.assign(this.state, {Suggestions: response.Suggestions})))
            .catch(e => console.log(e))
    }, 200);

    render() {
        return (
            <div>

                <form className="search" onSubmit={e => e.preventDefault()}
                      style={this.state.isFocused ? {zIndex: 2} : {}}>
                    <div className="search__wrapper">
                        <input type="text" name="" placeholder="Search for..." className="search__field"
                               onFocus={() => this.setState(Object.assign(this.state, {isFocused: true}))}
                               onChange={e => {
                                   this.setState(Object.assign(this.state, {text: e.target.value}));
                                   this.search(e.target.value)}}
                               value={this.state.text}
                               onBlur={() => this.setState(Object.assign(this.state, {isFocused: false}))}
                               onKeyUp={(k) => {
                                   if (k.key === 'Enter') {
                                       window.location = `/Results/ContentSearch?indexCatalogue=default&searchQuery=${encodeURIComponent(this.state.text)}&wordsMode=0`
                                   }
                               }}

                        />
                        <img src="/images/default-source/siteimages/iconsmenusystem/search.png" className="search__icon"
                             style={{maxHeight: "65px"}}
                             alt="Search"/>
                    </div>

                </form>
                <ul className="search__results">
                    {/*{this.state.Suggestions.map((item, idx) => {*/}
                    {/*return <a className="search__result__item" key={idx} href={'/'+item}>*/}
                    {/*<li style={idx === 0 ? {borderTop:"solid",borderWidth:"thin"} : {}}>{item}</li>*/}
                    {/*</a>*/}
                    {/*})}*/}

                </ul>
            </div>
        );
    }
}


//let domContainer = document.querySelector('#search-componentt');
//let domContainer2 = document.querySelector('#search-component');
//ReactDOM.render(<SearchComponent/>, domContainer);
//ReactDOM.render(<SearchComponent/>, domContainer2);
